import { render } from 'vue'
import ConfirmModal from '../shifts/ConfirmModal.vue'

export default {
    components: { ConfirmModal },
    methods: {
        async openModal(elementId, config = {}) {
            let element = document.getElementById(elementId)
            let modal = await window.bootstrap.Modal.getOrCreateInstance(element, config)
            modal.show()
            return modal
        },
        async confirmModal(parentModalId, buttons = [], title = null, body = null) {
            if (! title) title = this.$trans.get('__JSON__.Are you sure?')
            if (! body) body = this.$trans.get('__JSON__.This action can not be undone.')

            const props = { title, body, buttons, parentModalId }

            if (buttons.length === 0) {
                alert('buttons are required within the confirm modal')
                return
            }

            if (typeof body === "object") {
                const content = body
                const newProps = {...props, body: ''}
                render(<ConfirmModal {...newProps}>
                    {content}
                </ConfirmModal>, document.body)
            }
            else render(<ConfirmModal {...props} />, document.body)

            const modal = await window.bootstrap.Modal.getOrCreateInstance(document.getElementById('confirm_modal'), {
                backdrop: 'static',
                keyboard: false,
            })

            document.getElementById(parentModalId).style.display = 'none'
            modal.show()
        },
        async closeConfirm(parentModalId) {
            await this.closeModal(parentModalId)
            await this.closeModal('confirm_modal')
        },
        async closeModal(elementId) {
            await window.bootstrap.Modal.getOrCreateInstance(document.getElementById(elementId)).hide()
        },
        async listenModal(elementId, event, closure) {
            let modal = await document.getElementById(elementId)
            modal.addEventListener(event, closure)
        },
        confirm(question, onConfirmed) {
            // TODO: check if we can make a dynamic modal here :) bootstrap style
            if (window.confirm(question)) onConfirmed()
        },
    },
}
